import * as React from "react"; 
import { useState, useEffect } from "react";
import Modal from "../core/Modal";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from "../core/Button";
import { jfetch, toast } from "../../utils";

function IntroModal(props){

  const [showModal, setShowModal] = useState(false)
  const [value, setValue] = useState('')
  const [updates, setUpdates] = useState([])
  const [coreUpdate, setCoreUpdate] = useState('')
  const [loading, setLoading] = useState(false)
  
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['link', 'image', 'video'],
      ['clean']
    ],
  }

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ]

  useEffect(() => {
    jfetch.get('/global_settings/show').then((resp) => {
      setValue(resp.setting.intro_text)
    })
    jfetch.get('/global_settings/index_software').then((resp) => {
      setUpdates(resp.core_updates)
    })
  }, [])

  async function updateModal(){
    const data = {
      global_setting:{
        intro_text:value
      }
    }
    await jfetch.patch('/global_settings/update', data)
    setShowModal(false)
    toast.success('Intro Modal Saved!')
  }

  async function submitSoftwareUpdate(){
    setLoading(true)
    const data = {
      core_update:{
        info: coreUpdate
      }
    }
    await jfetch.post('/global_settings/create_software', data)
    setCoreUpdate('')
    setLoading(false)
    toast.success('Core Update Added!')
  }


  return(
    <div className="intro-modal-edit">
      <a onClick={() => setShowModal(true)} style={{cursor:'pointer'}}> 
        Edit Intro Modal
      </a>
      <Modal
        title="Intro Modal Editor"
        open={showModal}
        close={() => setShowModal(false)}
        submittable={true}
        isLarge={true}
        disallowClickOutside={true}
        submitText="Save"
        onSubmit={updateModal}
      >
        <div className="container-fluid" style={{margin:'0px'}}>
          <div className="row">
            <div className="col-lg-12">
              <label>Intro Text:</label>
            </div>
          </div>
          <div className="row" style={{marginBottom:'35px'}}>
            <div className="col-lg-12">
              <ReactQuill 
                theme="snow" 
                value={value} 
                onChange={setValue}
                modules={modules}
                formats={formats}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <label>New Software Update:</label>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <textarea rows={3} value={coreUpdate} onChange={(e) => setCoreUpdate(e.target.value) } />
            </div>
          </div> 
          <div className="row">
            <div className="col-lg-6">
              <Button color="info" loading={loading} onClick={submitSoftwareUpdate}>
                Add
              </Button>
            </div>
          </div>        
        </div>
      </Modal>
    </div>
  )
}

export default IntroModal


// WEBPACK FOOTER //
// ./app/javascript/components/pages/IntroModal.tsx